/**
 * Input Schema of Address
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Address} from '@/model/resource/Address'

/* TODO: review generated schema */
export class InputAddressSchema extends Schema {
  readonly name = 'InputAddress'

  readonly fieldSet: FieldSet<Address> = {
    street: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'max:255|required',
        inputClass: 'uppercase',
      },
    }),
    neighborhood: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'max:255|required',
        inputClass: 'uppercase',
      },
    }),
    city: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'max:255|required',
        inputClass: 'uppercase',
      },
    }),
  }
}
